<template>
  <div>
    <header :class="['header', { 'header-sticky': isSticky }]">
      <div class="logo">
        <div class="header-logo">
          <img src="@/assets/logo-1.png" alt="学校LOGO">
        </div>
      </div>
      <button class="nav-toggle" @click="toggleMobileNav" aria-label="打开菜单" aria-expanded="isMobileOpen">
        <i class="fas c-black" :class="isMobileOpen ? 'fa-times' : 'fa-bars'"></i>
      </button>
      <nav :class="['nav', { 'nav-open': isMobileOpen }]">
        <router-link
            v-for="(item, index) in navItems"
            :key="index"
            :to="item.path"
            class="nav-link"
            @click.native="closeMobileNav"
        >
          {{ item.name }}
        </router-link>
      </nav>
    </header>
    <div v-if="isMobileOpen" class="nav-backdrop" @click="closeMobileNav"></div>

    <button
        v-show="showBackToTop"
        @click="scrollToTop"
        class="back-to-top"
    >
      <i class="fas fa-rocket"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SHeader',
  data() {
    return {
      schoolName: '杉原美校',
      isSticky: false,
      showBackToTop: false,
      isMobileOpen: false,
      navItems: [
        { name: '首页', path: '/' },
        { name: '学校介绍', path: '/about' },
        { name: '学校环境', path: '/environment' },
        { name: '师资介绍', path: '/teachers' },
        { name: '历史成绩', path: '/history' },
        // { name: '校园设施', path: '/facilities' },
        // { name: '优秀作业', path: '/works' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      // 控制吸顶效果
      this.isSticky = window.scrollY > 100
      // 控制返回顶部按钮显示
      this.showBackToTop = window.scrollY > 300
    },
    toggleMobileNav() {
      this.isMobileOpen = !this.isMobileOpen
      document.body.style.overflow = this.isMobileOpen ? 'hidden' : ''
    },
    closeMobileNav() {
      this.isMobileOpen = false
      document.body.style.overflow = ''
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  //background: rgba(21, 28, 38, 0.55);
  background: #FDAA02;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255,255,255,0.08);
  color: white;
  padding: 0.75rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  position: relative;
  z-index: 1000;
}

.header-sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 0.5rem 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  animation: slideDown 0.3s ease-out;
  background: rgba(21, 28, 38, 0.75);
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.logo h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  background: linear-gradient(45deg, var(--default-red-color), #2c3e50);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  transition: all 0.3s;
}

.header-sticky .logo h1 {
  font-size: 1.2rem;
}

.nav {
  display: flex;
  gap: 1.5rem;
}

.nav-link {
  //color: white;
  color: #000000;
  text-decoration: none;
  padding: 0.5rem 1rem;
  position: relative;
  font-weight: 500;
  transition: all 0.3s;
  border-radius: 4px;
}

.nav-link:hover {
  //color: var(--default-red-color);
  background-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.nav-link::before {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: var(--default-red-color);
  transition: width 0.3s;
}

.nav-link:hover::before {
  width: 100%;
}

.nav-link.router-link-exact-active {
  color: var(--default-red-color);
  font-weight: 600;
}

.nav-link.router-link-exact-active::before {
  width: 100%;
}

/* 移动端菜单按钮 */
.nav-toggle {
  display: none;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.25rem;
  cursor: pointer;
}

.back-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--default-red-color);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
  z-index: 999;
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.3s forwards;
}

.back-to-top:hover {
  background-color: #3aa876;
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.back-to-top i {
  font-size: 1.2rem;
}

.header-logo {
  height: 60px;

  img {
    object-fit: contain;  /* 还有 contain, fill, none 等选项 */
    width: 100%;
    height: 100%;
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 0.75rem 1rem;
  }

  .nav-toggle { display: block; }
  .nav {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    //background: linear-gradient(180deg, rgba(21,28,38,0.96), rgba(21,28,38,0.88));
    background: rgba(0, 0, 0, 0.6);
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(255,255,255,0.06);
    display: none;
    flex-direction: column;
    padding: 0.5rem 0.75rem 0.75rem;
  }
  .nav.nav-open { display: flex; }

  .nav-link {
    color: white;
    padding: 0.9rem 0.75rem;
    font-size: 1.05rem;
    border-radius: 10px;
    margin: 2px 0;
  }
  .nav-link.router-link-exact-active { background: rgba(255,255,255,0.08); color: #a3ffd6; }

  .header-sticky {
    padding: 0.5rem;
  }

  .header-sticky .logo h1 {
    font-size: 1rem;
  }

  /* 移动端展开遮罩 */
  .nav-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.45);
    backdrop-filter: blur(1px);
    z-index: 900;
  }
}
</style>
